// extracted by mini-css-extract-plugin
export var active = "_sp-1";
export var circle = "_sp-0";
export var completed = "_sp-2";
export var connector = "_sp-4";
export var connectorCompleted = "_sp-7";
export var connectorSpacer = "_sp-5";
export var iconStrokeOverride = "_sp-8";
export var labelContainer = "_sp-6";
export var pending = "_sp-3";